export var ClassicGameId;
(function (ClassicGameId) {
    ClassicGameId[ClassicGameId["LUCKY7"] = 1] = "LUCKY7";
    ClassicGameId[ClassicGameId["LUCKY6"] = 9] = "LUCKY6";
    ClassicGameId[ClassicGameId["LUCKY5"] = 3] = "LUCKY5";
    ClassicGameId[ClassicGameId["DICE_DUEL"] = 10] = "DICE_DUEL";
    ClassicGameId[ClassicGameId["WHEEL"] = 7] = "WHEEL";
    ClassicGameId[ClassicGameId["POKER"] = 5] = "POKER";
    ClassicGameId[ClassicGameId["SIX_PLUS_POKER"] = 12] = "SIX_PLUS_POKER";
    ClassicGameId[ClassicGameId["BACCARAT"] = 6] = "BACCARAT";
    ClassicGameId[ClassicGameId["WAR"] = 8] = "WAR";
    ClassicGameId[ClassicGameId["STS_POKER"] = 14] = "STS_POKER";
    ClassicGameId[ClassicGameId["RNG_WHEEL"] = 16] = "RNG_WHEEL";
    ClassicGameId[ClassicGameId["RNG_FOOTBALL_GRID"] = 17] = "RNG_FOOTBALL_GRID";
    ClassicGameId[ClassicGameId["BETWAY_LUCKY7"] = 21] = "BETWAY_LUCKY7";
    ClassicGameId[ClassicGameId["RNG_LUCKY7"] = 26] = "RNG_LUCKY7";
    ClassicGameId[ClassicGameId["RNG_ROULETTE"] = 28] = "RNG_ROULETTE";
    ClassicGameId[ClassicGameId["SHOVA52"] = 29] = "SHOVA52";
    ClassicGameId[ClassicGameId["ROULETTE_EURO_GE"] = 30] = "ROULETTE_EURO_GE";
    ClassicGameId[ClassicGameId["ROULETTE_EURO_LT"] = 31] = "ROULETTE_EURO_LT";
    ClassicGameId[ClassicGameId["ROULETTE_AMERICAN_GE"] = 32] = "ROULETTE_AMERICAN_GE";
    ClassicGameId[ClassicGameId["ROULETTE_FLASH_LT"] = 38] = "ROULETTE_FLASH_LT";
    ClassicGameId[ClassicGameId["RGS_ROULETTE_EURO"] = 68] = "RGS_ROULETTE_EURO";
    ClassicGameId[ClassicGameId["LUCKY_KICKS"] = 33] = "LUCKY_KICKS";
    ClassicGameId[ClassicGameId["LUCKY_LENNY"] = 101] = "LUCKY_LENNY";
    // Skyward games
    ClassicGameId[ClassicGameId["SKYWARD"] = 27] = "SKYWARD";
    ClassicGameId[ClassicGameId["SKYWARD_GLS"] = 47] = "SKYWARD_GLS";
    ClassicGameId[ClassicGameId["SKYWARD_CAP"] = 62] = "SKYWARD_CAP";
    ClassicGameId[ClassicGameId["SKYWARD_DELUXE"] = 91] = "SKYWARD_DELUXE";
    ClassicGameId[ClassicGameId["SKYWARD_100"] = 102] = "SKYWARD_100";
    // PLS Game Ids - T=Table
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T1"] = 34] = "PLS_BLACKJACK_T1";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T2"] = 35] = "PLS_BLACKJACK_T2";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T3"] = 36] = "PLS_BLACKJACK_T3";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T4"] = 37] = "PLS_BLACKJACK_T4";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T5"] = 43] = "PLS_BLACKJACK_T5";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T6"] = 44] = "PLS_BLACKJACK_T6";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T7"] = 45] = "PLS_BLACKJACK_T7";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T8"] = 46] = "PLS_BLACKJACK_T8";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T9"] = 63] = "PLS_BLACKJACK_T9";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T10"] = 73] = "PLS_BLACKJACK_T10";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T11"] = 74] = "PLS_BLACKJACK_T11";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T12"] = 75] = "PLS_BLACKJACK_T12";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T13"] = 76] = "PLS_BLACKJACK_T13";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T14"] = 77] = "PLS_BLACKJACK_T14";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T15"] = 78] = "PLS_BLACKJACK_T15";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T16"] = 141] = "PLS_BLACKJACK_T16";
    // ShowGames
    ClassicGameId[ClassicGameId["STARZLE"] = 22] = "STARZLE";
    ClassicGameId[ClassicGameId["GIZA"] = 23] = "GIZA";
    // Slot Games - Hinterzimmer Games
    ClassicGameId[ClassicGameId["CITRUS_SPLASH"] = 39] = "CITRUS_SPLASH";
    ClassicGameId[ClassicGameId["CANDY_COINS"] = 40] = "CANDY_COINS";
    ClassicGameId[ClassicGameId["LOTUS_WEALTH_WONDERS"] = 41] = "LOTUS_WEALTH_WONDERS";
    ClassicGameId[ClassicGameId["LOTUS_WEALTH_WONDERS_DELUXE"] = 86] = "LOTUS_WEALTH_WONDERS_DELUXE";
    ClassicGameId[ClassicGameId["LOTUS_WEALTH_WONDERS_DELUXE_RTP_94"] = 85] = "LOTUS_WEALTH_WONDERS_DELUXE_RTP_94";
    ClassicGameId[ClassicGameId["LOTUS_WEALTH_WONDERS_DELUXE_RTP_96"] = 87] = "LOTUS_WEALTH_WONDERS_DELUXE_RTP_96";
    ClassicGameId[ClassicGameId["GIZA_SLOT"] = 42] = "GIZA_SLOT";
    ClassicGameId[ClassicGameId["GIZA_SLOT_RTP_94"] = 64] = "GIZA_SLOT_RTP_94";
    ClassicGameId[ClassicGameId["GIZA_SLOT_RTP_96"] = 65] = "GIZA_SLOT_RTP_96";
    ClassicGameId[ClassicGameId["BAD_BABOONS"] = 57] = "BAD_BABOONS";
    ClassicGameId[ClassicGameId["BAD_BABOONS_RTP_94"] = 56] = "BAD_BABOONS_RTP_94";
    ClassicGameId[ClassicGameId["BAD_BABOONS_RTP_96"] = 58] = "BAD_BABOONS_RTP_96";
    ClassicGameId[ClassicGameId["DRAGONS_FATE"] = 66] = "DRAGONS_FATE";
    ClassicGameId[ClassicGameId["DRAGONS_FATE_RTP_94"] = 69] = "DRAGONS_FATE_RTP_94";
    ClassicGameId[ClassicGameId["DRAGONS_FATE_RTP_96"] = 70] = "DRAGONS_FATE_RTP_96";
    ClassicGameId[ClassicGameId["LUCKY_LOKI"] = 67] = "LUCKY_LOKI";
    ClassicGameId[ClassicGameId["LUCKY_LOKI_RTP_94"] = 71] = "LUCKY_LOKI_RTP_94";
    ClassicGameId[ClassicGameId["LUCKY_LOKI_RTP_96"] = 72] = "LUCKY_LOKI_RTP_96";
    ClassicGameId[ClassicGameId["GIZA_SLOT_DELUXE"] = 80] = "GIZA_SLOT_DELUXE";
    ClassicGameId[ClassicGameId["GIZA_SLOT_DELUXE_RTP_94"] = 79] = "GIZA_SLOT_DELUXE_RTP_94";
    ClassicGameId[ClassicGameId["GIZA_SLOT_DELUXE_RTP_96"] = 81] = "GIZA_SLOT_DELUXE_RTP_96";
    ClassicGameId[ClassicGameId["FOREST_FRENZY"] = 83] = "FOREST_FRENZY";
    ClassicGameId[ClassicGameId["FOREST_FRENZY_RTP_94"] = 82] = "FOREST_FRENZY_RTP_94";
    ClassicGameId[ClassicGameId["FOREST_FRENZY_RTP_96"] = 84] = "FOREST_FRENZY_RTP_96";
    ClassicGameId[ClassicGameId["BAD_BABOONS_DELUXE"] = 99] = "BAD_BABOONS_DELUXE";
    ClassicGameId[ClassicGameId["BAD_BABOONS_DELUXE_RTP_94"] = 98] = "BAD_BABOONS_DELUXE_RTP_94";
    ClassicGameId[ClassicGameId["BAD_BABOONS_DELUXE_RTP_96"] = 100] = "BAD_BABOONS_DELUXE_RTP_96";
    ClassicGameId[ClassicGameId["GOLDEN_ADVENTURE"] = 89] = "GOLDEN_ADVENTURE";
    ClassicGameId[ClassicGameId["GOLDEN_ADVENTURE_RTP_94"] = 88] = "GOLDEN_ADVENTURE_RTP_94";
    ClassicGameId[ClassicGameId["GOLDEN_ADVENTURE_RTP_96"] = 90] = "GOLDEN_ADVENTURE_RTP_96";
    ClassicGameId[ClassicGameId["BUFFALO_WILDS"] = 107] = "BUFFALO_WILDS";
    ClassicGameId[ClassicGameId["BUFFALO_WILDS_RTP_94"] = 106] = "BUFFALO_WILDS_RTP_94";
    ClassicGameId[ClassicGameId["BUFFALO_WILDS_RTP_96"] = 108] = "BUFFALO_WILDS_RTP_96";
    ClassicGameId[ClassicGameId["OLYMPUS_GOLD"] = 104] = "OLYMPUS_GOLD";
    ClassicGameId[ClassicGameId["OLYMPUS_GOLD_RTP_94"] = 103] = "OLYMPUS_GOLD_RTP_94";
    ClassicGameId[ClassicGameId["OLYMPUS_GOLD_RTP_96"] = 105] = "OLYMPUS_GOLD_RTP_96";
    ClassicGameId[ClassicGameId["FRUIT_FIRE_7"] = 120] = "FRUIT_FIRE_7";
    ClassicGameId[ClassicGameId["FRUIT_FIRE_7_RTP_94"] = 119] = "FRUIT_FIRE_7_RTP_94";
    ClassicGameId[ClassicGameId["FRUIT_FIRE_7_RTP_96"] = 121] = "FRUIT_FIRE_7_RTP_96";
    ClassicGameId[ClassicGameId["BLING_BONANZA"] = 117] = "BLING_BONANZA";
    ClassicGameId[ClassicGameId["BLING_BONANZA_RTP_94"] = 116] = "BLING_BONANZA_RTP_94";
    ClassicGameId[ClassicGameId["BLING_BONANZA_RTP_96"] = 118] = "BLING_BONANZA_RTP_96";
    ClassicGameId[ClassicGameId["RESPIN_RICHES"] = 114] = "RESPIN_RICHES";
    ClassicGameId[ClassicGameId["RESPIN_RICHES_RTP_94"] = 113] = "RESPIN_RICHES_RTP_94";
    ClassicGameId[ClassicGameId["RESPIN_RICHES_RTP_96"] = 115] = "RESPIN_RICHES_RTP_96";
    ClassicGameId[ClassicGameId["PLINKO_RTP_96"] = 109] = "PLINKO_RTP_96";
    // Branded Slot Games
    ClassicGameId[ClassicGameId["CITRUS_SPLASH_HWB"] = 48] = "CITRUS_SPLASH_HWB";
    ClassicGameId[ClassicGameId["CITRUS_SPLASH_BETWAY"] = 49] = "CITRUS_SPLASH_BETWAY";
    ClassicGameId[ClassicGameId["CITRUS_SPLASH_SUNBET"] = 110] = "CITRUS_SPLASH_SUNBET";
    ClassicGameId[ClassicGameId["CANDY_COINS_HWB"] = 50] = "CANDY_COINS_HWB";
    ClassicGameId[ClassicGameId["CANDY_COINS_BETWAY"] = 51] = "CANDY_COINS_BETWAY";
    ClassicGameId[ClassicGameId["CANDY_COINS_SUNBET"] = 97] = "CANDY_COINS_SUNBET";
    ClassicGameId[ClassicGameId["LOTUS_WEALTH_WONDERS_HWB"] = 52] = "LOTUS_WEALTH_WONDERS_HWB";
    ClassicGameId[ClassicGameId["LOTUS_WEALTH_WONDERS_BETWAY"] = 53] = "LOTUS_WEALTH_WONDERS_BETWAY";
    ClassicGameId[ClassicGameId["GIZA_SLOT_BETWAY"] = 54] = "GIZA_SLOT_BETWAY";
    ClassicGameId[ClassicGameId["GIZA_SLOT_OLIMP"] = 55] = "GIZA_SLOT_OLIMP";
    ClassicGameId[ClassicGameId["GIZA_SLOT_HWB"] = 112] = "GIZA_SLOT_HWB";
    ClassicGameId[ClassicGameId["BAD_BABOONS_BETWAY"] = 96] = "BAD_BABOONS_BETWAY";
    ClassicGameId[ClassicGameId["DRAGONS_FATE_ONE_WIN"] = 111] = "DRAGONS_FATE_ONE_WIN";
    // Tap Games
    ClassicGameId[ClassicGameId["PENGUIN_RUSH"] = 59] = "PENGUIN_RUSH";
    // Branded Tap Games
    ClassicGameId[ClassicGameId["PENGUIN_RUSH_HWB"] = 60] = "PENGUIN_RUSH_HWB";
    ClassicGameId[ClassicGameId["PENGUIN_RUSH_NEW_THEME"] = 61] = "PENGUIN_RUSH_NEW_THEME";
    ClassicGameId[ClassicGameId["PENGUIN_RUSH_SPORTPESA_RTP_96"] = 92] = "PENGUIN_RUSH_SPORTPESA_RTP_96";
    ClassicGameId[ClassicGameId["PENGUIN_RUSH_OLIMP_RED_RTP_96"] = 93] = "PENGUIN_RUSH_OLIMP_RED_RTP_96";
    ClassicGameId[ClassicGameId["PENGUIN_RUSH_ONE_WIN_RTP_96"] = 94] = "PENGUIN_RUSH_ONE_WIN_RTP_96";
})(ClassicGameId || (ClassicGameId = {}));
